const DEFAULT_API_URL = 'http://localhost:3001'

export const API_BASE_URL = (process.env.VUE_APP_API_URL || DEFAULT_API_URL).replace(/\/$/, '')

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${API_BASE_URL}${normalizedPath}`
}
